import React from 'react';
import { Clock, BarChart2, GraduationCap } from 'lucide-react';
import AppLauncherItem from './AppLauncherItem';
import type { LucideIcon } from 'lucide-react';

const appItems: { key: string; Icon: LucideIcon; title: string; url: string; backgroundColor: string }[] = [
  {
    key: 'timeEntry',
    Icon: Clock,
    title: 'Time Entry',
    url: 'https://pbsapps.teampbs.com/timeentry/client/',
    backgroundColor: '#306b93',
  },
  {
    key: 'dataCollection',
    Icon: BarChart2,
    title: 'Data Collection',
    url: 'https://datacollection.teampbs.com/',
    backgroundColor: '#308C88',
  },
  {
    key: 'lms',
    Icon: GraduationCap,
    title: 'LMS',
    url: 'https://lms.teampbs.com/',
    backgroundColor: '#306b66',
  },
];

interface AppLauncherModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const AppLauncherModal: React.FC<AppLauncherModalProps> = ({ isOpen, onDismiss }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Transparent backdrop — click outside closes the launcher */}
      <div className="fixed inset-0 z-[999]" onClick={onDismiss} />

      {/* Launcher panel */}
      <div className="fixed top-[50px] left-[10px] z-[1000] bg-popover border border-border rounded-lg shadow-lg p-4">
        <h2 className="font-semibold text-sm mb-3 text-popover-foreground">PBS Apps</h2>
        <div className="flex flex-wrap gap-2">
          {appItems.map(item => (
            <AppLauncherItem
              key={item.key}
              Icon={item.Icon}
              title={item.title}
              url={item.url}
              backgroundColor={item.backgroundColor}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default AppLauncherModal;
